import React, { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { initialize as initializeAnalytics, trackPageLoad } from '@fff-web/fff-analytics';
import LoadingSpinner from '@fff-web/fff-ui-shared/LoadingSpinner';
import { PaymentProvider, PricesProvider, HCaptchaProvider } from '@fff-web/fff-payments';
import FMCHeader from '../../components/Header/FMCHeader';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import GTBCheckoutProvider from './ContextProviders/GTBContext';
import SharedProvider, { useSharedContext } from './ContextProviders/SharedContext';
import Checkout from '../../components/Checkout';
import EXPERIENCE_FLOW from '../../utils/constants/experienceFlow';

const GTBCustomizePage = () => {
  const { viewSize } = useAppContext();
  const { prospect, planCode, initialLoading } = useSharedContext();
  const { email } = prospect;
  const [analyticsInitialized, setAnalyticsInitialized] = useState(false);
  const { enableApplePaySocialEcomm } = useFlags();

  useEffect(() => {
    document.title = 'FabFitFun - Beauty, Fitness, Lifestyle';
  }, []);

  useEffect(() => {
    initializeAnalytics().then(() => {
      setAnalyticsInitialized(true);
    });
  });

  useEffect(() => {
    if (analyticsInitialized && planCode && email) {
      trackPageLoad({
        pathName: window.location.pathname,
        properties: {
          email,
          plan_code: planCode,
        },
      });
    }
  }, [analyticsInitialized, planCode, email]);

  if (initialLoading) return <LoadingSpinner />;

  return (
    <>
      <FMCHeader viewSize={viewSize} />
      <Checkout
        title="Checkout Your Box"
        emailDisabled
        focusField="password"
        flags={{ enableApplePaySocialEcomm }}
        validateOnMount="email"
      />
    </>
  );
};

GTBCustomizePage.defaultProps = {
  flags: {
    enableApplePaySocialEcomm: false,
  },
};

const WrappedGTBCustomizePage = () => (
  <HCaptchaProvider>
    <PaymentProvider>
      <PricesProvider>
        <SharedProvider experienceFlow={EXPERIENCE_FLOW.gtb}>
          <GTBCheckoutProvider>
            <GTBCustomizePage />
          </GTBCheckoutProvider>
        </SharedProvider>
      </PricesProvider>
    </PaymentProvider>
  </HCaptchaProvider>
);

WrappedGTBCustomizePage.defaultProps = {
  flags: {
    enableApplePaySocialEcomm: false,
  },
};

export default WrappedGTBCustomizePage;
